import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserProfileConfig } from '../models/config-user-profile.model';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {

  public userData$: BehaviorSubject<UserProfileConfig | null> =
    new BehaviorSubject<UserProfileConfig | null>(null);

  /** Costruttore */
  constructor() {}

  /**
   * User set properties
   */

  public setUserProperties(user: UserProfileConfig | null): void {
    this.userData$.next(user);
  }

  public clearUserInfo(): void {
    this.userData$.next(null);
  }
}
